import { RouterModule } from '@angular/router';

import { CursoComponent } from './curso/curso.component';
import { InscricaoComponent } from './inscricao.component';
import { DadosPessoaisComponent } from './dados-pessoais/dados-pessoais.component';
import { AgendamentoComponent } from './agendamento/agendamento.component';
import { NotaEnemComponent } from './nota-enem/nota-enem.component';
import { SobreProvaComponent } from './sobre-prova/sobre-prova.component';
import { SobreCursoComponent } from './sobre-curso/sobre-curso.component';
import { PagamentoInscricaoComponent } from './pagamento/pagamento.component';
import { FinalizacaoComponent } from './finalizacao/finalizacao.component';

export const INSCRICAO_ROUTER = [
  {
    path: 'inscricao/:ano/:id',
    component: InscricaoComponent,
    name: 'inscricao',
    children: [
      { path: 'curso', component: CursoComponent },
      { path: 'curso/:data', component: CursoComponent },
      { path: 'dados-pessoais', component: DadosPessoaisComponent },
      { path: 'agendamento', component: AgendamentoComponent },
      { path: 'nota-enem', component: NotaEnemComponent },
      { path: 'sobre-a-prova', component: SobreProvaComponent },
      { path: 'sobre-o-curso', component: SobreCursoComponent },
      { path: 'pagamento', component: PagamentoInscricaoComponent },
      { path: 'finalizacao', component: FinalizacaoComponent },
    ],
  },
];

export const InscricaoRouter = RouterModule.forChild(INSCRICAO_ROUTER);
